import { motion } from "framer-motion";
import styled from "./../../../styles/styled";

export const BrowserIconContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 32px;
  max-height: 32px;
  width: 100%;
  height: 100%;
  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`;
